import { styled } from '@mui/system';
import { TableCell } from '@src/common/components/Table';
import { TableRow } from '@src/common/components/TableRow';
import { theme } from '@src/common/styles/Theme';

export const BorderedTableCell = styled(TableCell)`
  border-right: 1px solid ${theme.palette.surface.outlineVariant};
`;

export const HeaderBorderedTableCell = styled(TableCell)`
  border-top: 1px solid ${theme.palette.surface.outlineVariant};
  border-right: 1px solid ${theme.palette.surface.outlineVariant};
`;

export const SubHeaderBorderedTableCell = styled(HeaderBorderedTableCell)`
  border-bottom: ${theme.table.border.secondary};
`;

export const WideRow = styled(TableRow)`
  & > th:not(:first-of-type),
  & > td:not(:first-of-type) {
    width: 160px;
  }
`;
